<app-background-image data-state="sustainability"></app-background-image>
<app-topbar></app-topbar>

<app-sidebar>
    <ul class="nav flex-column navbar-nav">
        <li class="d-grid gap-2">
            <a class="btn btn-outline-primary btn-block"
               routerLink="/sustainability/esg">
                ESG data
            </a>
        </li>
        <li *ngIf="showProjectCo2Consumption" class="d-grid gap-2">
            <a class="btn btn-outline-primary btn-block"
               routerLink="/sustainability/co2consumption">
                Edit Co2 Consumption
            </a>
        </li>
        <li *ngIf="showProjectCo2Consumption" class="d-grid gap-2">
            <a class="btn btn-outline-primary btn-block"
               routerLink="/sustainability/disclaimer">
                Edit Disclaimer
            </a>
        </li>
    </ul>
</app-sidebar>
<ng-container>
    <div class="main-content">
        <div class="esg-report">
            <h3>ESG report</h3>
            <div style="display: grid; grid-template-columns: auto 40%">
                <app-sustainability-esg-matrix [esgMatrixData]="esgMatrixData" *ngIf="esgMatrixData"></app-sustainability-esg-matrix>
                <app-sustainability-esg-chart [esgChartData]="esgChartData" *ngIf="esgChartData"></app-sustainability-esg-chart>
            </div>
        </div>
        <app-display-sustainability-disclaimer></app-display-sustainability-disclaimer>
    </div>
</ng-container>
